module.exports = require("redux");


//////////////////
// WEBPACK FOOTER
// external "redux"
// module id = 379
// module chunks = 0